import { merge } from 'lodash-es'
import { type ComputedRef, computed, unref } from 'vue-demi'
import { type MaybeRef } from '@vueuse/core'
import { LayoutModeConfig, LayoutModes } from '../types'
import { LayoutMode } from '../types/primitives'

export function useCurrentLayout<TConfig extends LayoutModeConfig = LayoutModeConfig> (currentMode: MaybeRef<LayoutMode | undefined>, modeConfig: LayoutModes<TConfig>): {
  currentLayout: ComputedRef<TConfig>
} {
  const currentLayout: ComputedRef<TConfig> = computed((): TConfig => {
    const mergeItems = [modeConfig?.default]
    const currentModeValue = unref(currentMode)
    if (currentModeValue != null) {
      mergeItems.push(modeConfig?.[currentModeValue])
    }
    return merge(
      {},
      ...mergeItems.filter((item) => item != null)
    )
  })
  return {
    currentLayout
  }
}
